import React, { useState } from 'react';
import { Form, Input, DatePicker, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import getBase64 from 'getbase64data'
import { uploadImage, createPost } from '../../firebase';

export function UserForm(props) {
  const [form] = Form.useForm();
  const[imageLink, setImageLink] = useState()
  const[loading, setLoading] = useState(false)

  const dummyRequest = async ({ file, onSuccess }) => {    
    setTimeout(() => {
       onSuccess("ok");
    }, 2000);
  }

  const  handleImageUpload  =  async  (file)  => {
    const  base64  =  await getBase64.fromFile(file)
    const downloadURL = await uploadImage(base64)
    console.log(downloadURL)
    setImageLink(downloadURL)
};
 
const onFinish = (data) => {
    setLoading(true)
    createPost(data, imageLink, props.name)
    setTimeout(() => {
        setLoading(false)
        props.closeDrawer()
    }, 2000)
}

  const fileProps = {
    name: 'file',
    multiple: false,
    customRequest: dummyRequest,
     onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log('uploading');
      }

      if (status === 'done') {
        handleImageUpload(info.file.originFileObj)
       message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Form.Item
        label="Type of Cat"
        name="catType"
        rules={[{ required: true, message: 'Please input your first name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Name of Cat"
        name="catName"
        rules={[{ required: true, message: 'Please input your last name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="upload"
        label="Upload Cat Picture"
      >
        <Upload {...fileProps}>
          <Button icon={<UploadOutlined />}>Click to upload</Button>
        </Upload>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" style={{ backgroundColor: '#6fbd3c' }} block loading={loading}>
          Create Post
        </Button>
      </Form.Item>
    </Form>
  );
}
